import React from "react";
import { useParams, Navigate } from "react-router-dom";

export default function AnalysisDetailsScreen() {
  const { analysisId } = useParams<{ analysisId: string }>();
  
  // Redirect to existing /analysis/:videoId route
  // analysisId from MVP route is the runId (works with VideoAnalysis)
  if (!analysisId) {
    return <Navigate to="/mvp/analysis" replace />;
  }
  
  return <Navigate to={`/analysis/${analysisId}`} replace />;
}

